import { getDefaultConfig } from "@rainbow-me/rainbowkit";
import { bsc, bscTestnet } from "wagmi/chains";
import {
  metaMaskWallet,
  injectedWallet,
  trustWallet,
  walletConnectWallet,
  safeWallet,
} from "@rainbow-me/rainbowkit/wallets";

export const wagmiConfig = getDefaultConfig({
  appName: "Monbase NFT",
  projectId: "fe44213ec6d4dd5a87f7517d5f03d6f2",
  chains: [bsc, bscTestnet],
  wallets: [
    {
      groupName: "Recommended",
      wallets: [metaMaskWallet, injectedWallet, trustWallet, walletConnectWallet, safeWallet],
    },
  ],
});
